import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

export const DefaultErrorPage = () => {
  const isMdAndSmaller = useMediaQuery('down', 'md')

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center gap-6">
      <Typography
        className="text-[130px] md:text-[96px]"
        color="primary"
        variant="h1"
      >
        <FormattedMessage id="errorBoundary.oops" />
      </Typography>
      <div className="flex flex-col gap-2 text-center">
        <Typography
          color="text.primary"
          variant={isMdAndSmaller ? 'h6' : 'h5'}
        >
          <FormattedMessage id="errorBoundary.title" />
        </Typography>
        <Typography
          color="text.secondary"
          variant={isMdAndSmaller ? 'body3' : 'body2'}
        >
          <FormattedMessage id="errorBoundary.description" />
        </Typography>
      </div>

      <Button
        color="primary"
        variant="contained"
        onClick={() => {
          window.location.reload()
        }}
      >
        <FormattedMessage id="common.controls.reloadThePage" />
      </Button>
    </div>
  )
}
